// removed by extract-text-webpack-plugin
module.exports = {"notes":"CentricUI__Modal__ModalNotes__notes","header":"CentricUI__Modal__ModalNotes__header","textHTML":"CentricUI__Modal__ModalNotes__textHTML","placeholderText":"CentricUI__Modal__ModalNotes__placeholderText"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/ModalNotes.css
// module id = 1093
// module chunks = 10